import React from 'react';
import type { LocalType } from '../types';
import { TYPE_STYLES, TYPE_LABELS } from '../constants';

interface FilterControlsProps {
  activeFilters: LocalType[];
  onFilterChange: (type: LocalType) => void;
}

const ALL_TYPES: LocalType[] = [
  "ristorante",
  "pizzeria",
  "gelateria",
  "pasticceria",
  "caffe",
  "bar",
  "osteria",
  "sushi",
  "street-food",
];

export const FilterControls: React.FC<FilterControlsProps> = ({ activeFilters, onFilterChange }) => {
  return (
    <div className="bg-white bg-opacity-80 backdrop-blur-sm p-3 rounded-lg shadow-lg border border-gray-200">
      <h3 className="text-sm font-bold text-gray-800 mb-2 sr-only">Filtri</h3>
      <div className="flex flex-wrap gap-2">
        {ALL_TYPES.map(type => {
          const isActive = activeFilters.includes(type);
          const style = TYPE_STYLES[type];
          const Icon = style.icon;
          return (
            <button
              key={type}
              onClick={() => onFilterChange(type)}
              className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-cyan-500
                ${isActive ? `${style.color} text-white shadow-md` : 'bg-white hover:bg-gray-100 text-gray-800 border border-gray-300'}`}
              aria-pressed={isActive}
            >
              <Icon className="w-4 h-4" />
              <span>{TYPE_LABELS[type]}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
